import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment } from '@material-ui/core';
import { Button, TextField } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../knock-design-system';
import {
  KNOCK_EMAIL_HELPER_TEXT,
  KNOCK_EMAIL_STATUS,
} from '../CreateProperty/constants';

const useCss = makeCss({
  checkAvailabilityButton: {
    alignSelf: 'flex-start',
    marginTop: '10px',
    width: '185px',
  },
});

export const KnockEmail = ({
  clearErrorMessage,
  errorMessage,
  handleOnChange,
  knockEmail = '',
  knockEmailStatus,
  validateEmailUsername,
}) => {
  const css = useCss();

  const isRelaySuccess = knockEmailStatus === KNOCK_EMAIL_STATUS.SUCCESS;
  const knockEmailIcon = isRelaySuccess && 'check-small';
  const isRelayProcessing = knockEmailStatus === KNOCK_EMAIL_STATUS.PROCESSING;
  const isAvailabilityButtonDisabled =
    isRelayProcessing || !knockEmail || isRelaySuccess;

  const knockEmailHelperText =
    errorMessage || KNOCK_EMAIL_HELPER_TEXT[knockEmailStatus];

  return (
    <React.Fragment>
      <TextField
        endAdornment={
          <InputAdornment position="end">@m.knck.io</InputAdornment>
        }
        error={!!errorMessage}
        helperText={knockEmailHelperText}
        id="knockEmail"
        label="Knock Email"
        name="knockEmail"
        onChange={handleOnChange}
        onFocus={clearErrorMessage}
        startIcon={knockEmailIcon}
        value={knockEmail}
        variant="outlined"
      />

      <Button
        css={css.checkAvailabilityButton}
        disabled={isAvailabilityButtonDisabled}
        loading={isRelayProcessing}
        onClick={validateEmailUsername}
        variant="text"
      >
        Check Availability
      </Button>
    </React.Fragment>
  );
};

KnockEmail.propTypes = {
  clearErrorMessage: PropTypes.func,
  errorMessage: PropTypes.string,
  handleOnChange: PropTypes.func,
  knockEmail: PropTypes.string,
  knockEmailStatus: PropTypes.string,
  validateEmailUsername: PropTypes.func,
};
